import React from 'react'
import { PaperFoldBox } from '../Core/PaperFoldBox'
import { Button, Divider, Grid, Container } from '@material-ui/core'
import DescriptionIcon from '@material-ui/icons/Description'
import FlexView from 'react-flexview/lib'
import { ReactComponent as Shield } from '../../assets/shield_with_v.svg'
import { ReactComponent as ShieldX } from '../../assets/shield_empty.svg'
import { ReactComponent as ShieldGray } from '../../assets/shield_expired.svg'
import { ReactComponent as ShieldClock } from '../../assets/shield_with_clock.svg'
import { ReactComponent as ShieldSuspend } from '../../assets/shield_suspended.svg'
import { ReactComponent as LiabilityShield } from '../../assets/liability_shield.svg'
import { ReactComponent as AutoRenewIcon } from '../../assets/renew.svg'
import DateRangeIcon from '@material-ui/icons/DateRange'
import './PolicyListCard.scss'
import { ActiveInsuranceModel } from '../../models/insurance-models/ActiveInsuranceModel'
import { InsuranceStatus } from '../../models/insurance-models/InsuranceStatus'
import dayjs from 'dayjs'
import { ElevatedCircle } from '../Core/ElevatedCircle'
import {
    FirebaseService,
    FirebaseConfigKey,
} from '../../services/FirebaseService'
import { InsuranceTypes } from '../../models/insurance-models/InsuranceBillingPeriodModel'
import {
    BrowserView,
    MobileView,
    isMobile,
    isBrowser,
} from 'react-device-detect'
import { TextButton } from '../Core/Buttons/TextButton'
import PersonIcon from '@material-ui/icons/Person'
import CreateIcon from '@material-ui/icons/Create'
import SettingsIcon from '@material-ui/icons/Settings'
import { useRouteMatch, useHistory } from 'react-router-dom'
import { isUK } from '../../services/utils'
var classNames = require('classnames')

interface PolicyListCardProps {
    insurance: ActiveInsuranceModel;
}

export const PolicyListCard = ({
    insurance,
    buttons,
    small,
    ...props
}: PolicyListCardProps) => {
    let { path, url } = useRouteMatch()
    const history = useHistory()

    const getStatus = () => {
        if (!small && insurance.getStatus() == InsuranceStatus.SCHEDULED) {
            let daysLeft = dayjs(insurance.insuranceStart).diff(
                new Date(),
                'day'
            )
            if (daysLeft < 1) return 'Will be active Tomorrow'
            return `Will be active in ${daysLeft} day${daysLeft > 1 ? 's' : ''}`
        } else
            return (
                <span
                    className={classNames(
                        'bold',
                        {
                            green:
                                insurance.getStatus() == InsuranceStatus.ACTIVE,
                        },
                        {
                            red:
                                insurance.getStatus() ==
                                InsuranceStatus.CANCELED,
                        },
                        {
                            grey:
                                insurance.getStatus() ==
                                InsuranceStatus.EXPIRED,
                        },
                        {
                            blue:
                                insurance.getStatus() ==
                                InsuranceStatus.SCHEDULED,
                        },
                        {
                            yellow:
                                insurance.getStatus() ==
                                InsuranceStatus.SUSPENDED,
                        }
                    )}
                >
                    {insurance.getStatus()}
                </span>
            )
    }

    let dateFormat =
        isMobile || small
            ? FirebaseService.getValue(
                  FirebaseConfigKey.SHORT_DATE_FORMAT
              ).toUpperCase()
            : FirebaseService.getValue(FirebaseConfigKey.LONG_DATE_FORMAT)

    const openPolicyView = () => {
        history.push(`${url}/${insurance.insuranceId}`, { open_details: true })
    }

    const openCertificateView = () => {
        history.push(`${url}/${insurance.insuranceId}`, { open_details: false })
    }

    const openAdditionalInsured = () => {
        history.push(`${url}/${insurance.insuranceId}`, {
            open_ai: true,
            open_details: true,
        })
    }

    const openPolicyUrl = () => {
        window.open(insurance.policyUrl, '_blank')
    }

    const openCOIUrl = () => {
        window.open(insurance.certificateUrl, '_blank')
    }

    const shieldClassName = classNames(
        { 'policy-card-list-shield': !small || isMobile },
        { 'margin-right-small': small },
        { 'large-icon': !small },
        { 'large-icon': small }
    )

    const getShield = () => {
        switch (insurance.getStatus()) {
            case InsuranceStatus.ACTIVE:
                return <Shield className={shieldClassName} />
            case InsuranceStatus.SCHEDULED:
                return <ShieldClock className={shieldClassName} />
            case InsuranceStatus.CANCELED:
                return <ShieldX className={shieldClassName} />
            case InsuranceStatus.EXPIRED:
                return <ShieldGray className={shieldClassName}/>
            case InsuranceStatus.SUSPENDED:
                return (
                    <ShieldSuspend
                        className={classNames(
                            shieldClassName,
                            'yellow-svg-path'
                        )}
                    />
                )
            default:
                return <Shield className={shieldClassName} />
        }
    }

    const mtIconClassName = classNames(
        { blue: insurance.isActive() },
        { powderblue: !insurance.isActive() }
    )
    const svgIconClassName = classNames(
        'x-medium-icon',
        { 'blue-svg-path': insurance.isActive() },
        { 'powderblue-path-svg': !insurance.isActive() }
    )

    return (
        <PaperFoldBox
            buttons={
                <FlexView
                    className={classNames('space-evenly', {
                        'padding-bottom-basic': isMobile,
                    })}
                >
                    {!!buttons ? (
                        buttons
                    ) : (
                        <React.Fragment>
                            {isMobile && (
                                <React.Fragment>
                                    <TextButton
                                        onClick={openCOIUrl}
                                        withBorder
                                        text={'View COI'}
                                        endIcon={
                                            <DescriptionIcon
                                                fontSize="small"
                                                className="blue"
                                            />
                                        }
                                    />
                                    <TextButton
                                        onClick={openPolicyUrl}
                                        withBorder
                                        text={'View Policy'}
                                        endIcon={
                                            <DescriptionIcon
                                                fontSize="small"
                                                className="blue"
                                            />
                                        }
                                    />
                                </React.Fragment>
                            )}
                            {isBrowser && (
                                <React.Fragment>
                                    {/* <div onClick={openCertificateView} className="policy-card-item-button card-button-left blue clickable text-body">
                        {insurance.isActiveOrSchedule() ? "Manage Certificates" : "View Certificates"}
                    </div> */}
                                    <div
                                        onClick={openPolicyView}
                                        className="policy-card-item-button card-button-right blue clickable text-body"
                                    >
                                        {insurance.isActiveOrSchedule()
                                            ? 'Manage Policy'
                                            : 'Policy Details'}
                                    </div>
                                </React.Fragment>
                            )}
                        </React.Fragment>
                    )}
                </FlexView>
            }
        >
            <BrowserView>
                <div
                    className={classNames(
                        { 'policy-list-card-title': !small },
                        { 'policy-list-card-title-small': small }
                    )}
                >
                    <FlexView
                        vAlignContent={'center'}
                        className="space-between"
                    >
                        <div className="text-small black">
                            <span className="bold margin-right-6">
                                Policy Number:
                            </span>
                            {insurance.policyNumber}
                            {!small && (
                                <React.Fragment>
                                    <span className="bold margin-right-6 margin-left-basic">
                                        Status:
                                    </span>
                                    {getStatus()}
                                </React.Fragment>
                            )}
                        </div>
                        <FlexView>
                            <TextButton
                                withBorder
                                onClick={openPolicyUrl}
                                endIcon={
                                    <DescriptionIcon
                                        fontSize="small"
                                        className="blue"
                                    />
                                }
                                text={'Policy'}
                            />
                            <TextButton
                                className="margin-left-6"
                                withBorder
                                onClick={openCOIUrl}
                                endIcon={
                                    <DescriptionIcon
                                        fontSize="small"
                                        className="blue"
                                    />
                                }
                                text={'COI'}
                            />
                        </FlexView>
                    </FlexView>
                    <Divider />
                </div>
            </BrowserView>
            <FlexView
                vAlignContent={'center'}
                column={!small || isMobile}
                hAlignContent={!small || isMobile ? 'center' : 'left'}
            >
                {getShield()}
                <div
                    className={classNames('text-title', 'bold', 'black', {
                        'margin-top-basic': !small || isMobile,
                    })}
                >
                    Your {insurance.insuranceType} Policy
                </div>
                <MobileView>
                    <div className="text-secondary black margin-top-basic">
                        {insurance.policyNumber} | {getStatus()}
                    </div>
                </MobileView>
            </FlexView>
            <Grid container className="margin-top-basic">
                <Grid item xs>
                    <FlexView hAlignContent={'center'} column>
                        <ElevatedCircle>
                            <LiabilityShield className={svgIconClassName} />
                        </ElevatedCircle>
                        <div className="text-tiny bold black margin-top-small">
                            Aircraft Type
                        </div>
                        {/* <div className="text-tiny black">{FirebaseService.getValue(FirebaseConfigKey.CURRENCY_SYMBOL)}{insurance.liabilityLimit.toLocaleString()}</div> */}
                        <div className="text-tiny textcenter black">
                            {insurance.insuredVehicles[0].multiEngineLand && (
                                <div>Multi Engine Land</div>
                            )}
                            {insurance.insuredVehicles[0].singleEngineLand && (
                                <div>Single Engine Land</div>
                            )}
                            {insurance.insuredVehicles[0]
                                .singleEngineSeaplane && (
                                <div>Single Engine Seaplane</div>
                            )}
                        </div>
                    </FlexView>
                </Grid>
                <Grid item xs>
                    <FlexView hAlignContent={'center'} column>
                        {insurance.insuranceType != InsuranceTypes.HOURLY ? (
                            <React.Fragment>
                                <ElevatedCircle>
                                    <AutoRenewIcon
                                        className={svgIconClassName}
                                    />
                                </ElevatedCircle>
                                <div className="text-tiny bold black margin-top-small">
                                    Auto Renew
                                </div>
                                <div className="text-tiny black">
                                    {insurance.autoRenew ? 'On' : 'Off'}
                                </div>
                            </React.Fragment>
                        ) : (
                            <React.Fragment>
                                <ElevatedCircle>
                                    <DateRangeIcon
                                        fontSize="default"
                                        className={mtIconClassName}
                                    />{' '}
                                </ElevatedCircle>
                                <div className="text-tiny bold black margin-top-small">
                                    Start Time
                                </div>
                                <div className="text-tiny black">
                                    {dayjs(insurance.insuranceStart).format(
                                        FirebaseService.getValue(
                                            FirebaseConfigKey.DATE_TIME_FORMAT
                                        )
                                    )}
                                </div>
                            </React.Fragment>
                        )}
                    </FlexView>
                </Grid>
                <Grid item xs>
                    <FlexView hAlignContent={'center'} column>
                        {insurance.insuranceType != InsuranceTypes.HOURLY ? (
                            <React.Fragment>
                                <ElevatedCircle>
                                    <DateRangeIcon
                                        fontSize="default"
                                        className={mtIconClassName}
                                    />
                                </ElevatedCircle>
                                <div className="text-tiny bold black margin-top-small">
                                    Coverage Period
                                </div>
                                <div className="text-tiny black">
                                    {dayjs(insurance.insuranceStart).format(
                                        dateFormat
                                    )}{' '}
                                    -{' '}
                                    {dayjs(insurance.insuranceEnd).format(
                                        dateFormat
                                    )}
                                </div>
                            </React.Fragment>
                        ) : (
                            <React.Fragment>
                                <ElevatedCircle>
                                    <DateRangeIcon
                                        fontSize="default"
                                        className={mtIconClassName}
                                    />{' '}
                                </ElevatedCircle>
                                <div className="text-tiny bold black margin-top-small">
                                    Duration
                                </div>
                                <div className="text-tiny black">
                                    {(insurance.durationInSeconds / 3600) | 0}{' '}
                                    Hour
                                    {insurance.durationInSeconds > 3600
                                        ? 's'
                                        : ''}
                                </div>
                            </React.Fragment>
                        )}
                    </FlexView>
                </Grid>
            </Grid>
            <MobileView>
                <Container>
                    {/* <Divider />
                    <FlexView className="space-between" vAlignContent={'center'}>
                        <FlexView vAlignContent={'center'}>
                            <PersonIcon className="lightgrayblue tiny-icon margin-right-3"  />
                            <div className="black text-small bold margin-right-6">Additional Insured</div>
                            <CreateIcon onClick={openAdditionalInsured} className="blue tiny-icon" />
                        </FlexView>
                        <TextButton onClick={openCertificateView} text="Manage COIs" underline /> 
                    </FlexView> */}
                    {/* <Divider />
                    <FlexView vAlignContent={'center'}>
                        <SettingsIcon className="lightgrayblue tiny-icon margin-right-3"  />
                        <div className="black text-small bold margin-right-6">Edit Policy</div>
                        <CreateIcon onClick={openPolicyView} className="blue tiny-icon" />
                    </FlexView> */}
                </Container>
            </MobileView>
        </PaperFoldBox>
    )
}
